import { Route } from "@angular/router";
import { LectureHistoriqueComponent } from "./lecture-historique.component";

export const LectureHistoriqueRouting: Route = {
  path: 'historique',
  component: LectureHistoriqueComponent,
  data: {
    breadcrumb: "Détail des lectures"
  },
};
